var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbcdClockTimeSevenIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM12.5 12.2L9.8 17L8.5 16.2L11 11.8V7H12.5V12.2Z",
    fill: "#E9A829"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbcdClockTimeSevenIcon);
export default __webpack_public_path__ + "static/media/abcd-clock-time-seven-icon.5c338cf16d55337ce24fc31eb73f142a.svg";
export { ForwardRef as ReactComponent };